import { Box, Container, Grid, Typography } from "@mui/material";
import PlatformMockup, { type MockupVariant } from "@/pages/landing/PlatformMockup";

const PREVIEWS: { variant: MockupVariant; title: string; caption: string }[] = [
  { variant: "scanner", title: "Market Scanner", caption: "AI-ranked bullish and bearish signals, updated continuously." },
  { variant: "options", title: "Options Dashboard", caption: "OI score, PCR, max pain and support/resistance in one view." },
  { variant: "portfolio", title: "Portfolio Tracker", caption: "Consolidated holdings, returns and risk across your account." },
  { variant: "algo", title: "Algo Strategies", caption: "Live strategy performance, ready to deploy through your broker." },
];

export function PlatformPreviewSection() {
  return (
    <Box sx={{ py: { xs: 10, md: 14 } }} id="platform-preview">
      <Container maxWidth="lg">
        <Box textAlign="center" maxWidth={560} mx="auto" mb={8}>
          <Typography variant="h4" fontWeight={800} mb={2}>
            A platform built for daily use
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Illustrative preview — your dashboard populates with your own broker, portfolio and
            market data after sign-in.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {PREVIEWS.map((preview) => (
            <Grid item xs={12} sm={6} key={preview.variant}>
              <PlatformMockup variant={preview.variant} compact />
              <Typography variant="subtitle1" fontWeight={700} mt={2}>
                {preview.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {preview.caption}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default PlatformPreviewSection;
